module.exports = {"serviceName":"보이스캐디 스마트 골프 서비스","title":"새로운 비밀번호를 등록하세요.","newPasswordPlaceholder":"새로운 비밀번호를 입력하세요","confirmPasswordPlaceholder":"새로운 비밀번호를 확인해주세요","resetPassword":"비밀번호 재설정"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/ma011.json
// module id = WoTq
// module chunks = 2